import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./app";
import { createAppQueryClient } from "./lib/query-client";
import "./index.css";
import "./tailwind.css";

const queryClient = createAppQueryClient();
const root = document.getElementById("root");

if (!root) {
  throw new Error("Missing root element.");
}

const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

ReactDOM.createRoot(root).render(app);
